import Vue from "vue";
import Vuex from "vuex";
import jQuery from "jquery";

Vue.use( Vuex );

export default new Vuex.Store( {
    state: {
        version: process.env.PACKAGE_VERSION || 'Production',
        initialized: false,
        loader: true,
        // api_url_base: 'http://dvca.vog',
        // api_url_base: '/',
        mode: 'buy',
        sort_order: 'asc',
        sort_key: '',
        title: 'Matching Listings',
        initialization: {
            stage: 0,
            stages: [
                { name: 'resorts', endpoint: 'resorts' },
                { name: 'brands', endpoint: 'resorts/brands' },
                { name: 'types', endpoint: 'listings/types' },
                { name: 'subtypes', endpoint: 'listings/subtypes_admin' }, // subtypes
                { name: 'sizes', endpoint: 'listings/sizes' },
                { name: 'use_years', endpoint: 'listings/use-years' },
                { name: 'use_year_rental', endpoint: 'listings/use_year_rental' },
                { name: 'statuses', endpoint: 'listings/statuses' }
            ]
            // 10,12,14,16,18,20,22,24,26

        },
        datasets: {
            resorts: [],
            brands: [],
            types: [],
            subtypes: [],
            sizes: [],
            use_years: [],
            use_year_rental: [],
            statuses: [],
            // max_prices: [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40 ],
            max_prices: [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40 ],
            // max_ppp: [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30 ],
            max_ppp_rental: [ 1, 1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.4, 2.6, 2.8, 3, 3.2, 3.4, 3.6, 3.8, 4 ],
            max_ppp_resale: [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35 ],
            max_points: [ 25, 50, 75, 100, 150, 200, 250, 300, 350, 400, 450, 500 ]
        },
        selections: {
            subtype: null,
            resort: null,
            resort_desired: null,
            brand: null,
            use_year: null,
            use_year_rental: null,
            status: null,
            type: null,
            size: null,
            max_points: null,
            max_price: null,
            max_ppp_rental: null,
            max_ppp_resale: null,
            max_ppp: null
        },
        detail: null,
        response: []
    },

    mutations: {
        set_value: function( state, payload ) {
            if ( payload ) {
                if ( payload.collection ) {
                    Vue.set( state[ payload.collection ], payload.attribute, payload.data );
                } else {
                    Vue.set( state, payload.attribute, payload.data );
                }
            }
        }
    },

    actions: {
        initialize: function( context ) {
            context.commit( 'set_value', { attribute: 'loader', data: true } );
            context.commit( 'set_value', { collection: 'initialization', attribute: 'stage', data: this.state.initialization.stage + 1 } );

            let step = this.state.initialization.stage;

            if ( step <= this.state.initialization.stages.length ) {
                jQuery.ajax(
                    // this.state.api_url_base + '/rest/api/' + this.state.initialization.stages[ step - 1 ].endpoint,
                    window.DVCA_PARAMS['CMSREST'] + '/rest/api/' + this.state.initialization.stages[ step - 1 ].endpoint,
                    {
                        dataType: 'json',
                        method: 'GET',
                        success: function( response ) {
                            if ( response ) {
                                let key;
                                let transformed = response;

                                if ( !response.length ) {
                                    transformed = [];

                                    for ( key in response ) {
                                        switch ( context.state.initialization.stages[ step - 1 ].name ) {
                                            case 'resorts' :
                                                transformed.push(
                                                    {
                                                        id: response[ key ].id,
                                                        name: response[ key ].name,
                                                        brand: response[ key ].id_type
                                                    }
                                                );
                                                break;

                                            default :
                                                transformed.push(
                                                    {
                                                        id: response[ key ],
                                                        name: key
                                                    }
                                                );
                                                break;
                                        }
                                    }
                                }

                                context.commit( 'set_value', { collection: 'datasets', attribute: context.state.initialization.stages[ step - 1 ].name, data: transformed } );
                                context.dispatch( 'initialize' );
                            } else {
                                let message = 'We apologize, but an error has occurred when initializing this page. Please try again, or let us know about the error on this page.';

                                /*
                                if ( typeof Swal !== 'undefined' ) {
                                    new Swal( 'Uh-oh!', message, 'error' );
                                } else {
                                    alert( message );
                                }
                                */

                                alert( message );
                            }
                        }
                    }
                )
            } else {
                context.commit( 'set_value', { attribute: 'loader', data: false } );
                context.commit( 'set_value', { attribute: 'initialized', data: true } );

                let root = jQuery( '.dvca-listings', document.body );

                if ( root.length ) {
                    let mode = root.data( 'mode' );
                    let title_override = root.data( 'title-override' );
                    let preset_type = parseInt( root.data( 'preset-type' ) );
                    let preset_status = parseInt( root.data( 'preset-status' ) );
                    let preset_resort = parseInt( root.data( 'preset-resort' ) );

                    if ( mode ) {
                        context.commit( 'set_value', { attribute: 'mode', data: mode } );
                    }

                    if ( title_override ) {
                        context.commit( 'set_value', { attribute: 'title', data: title_override } );
                    }

                    if ( ( !isNaN( preset_type ) ) && ( preset_type > 0 ) ) {
                        context.commit( 'set_value', { collection: 'selections', attribute: 'type', data: preset_type } );
                    }

                    if ( ( !isNaN( preset_status ) ) && ( preset_status > 0 ) ) {
                        context.commit( 'set_value', { collection: 'selections', attribute: 'status', data: preset_status } );
                    }

                    if ( ( !isNaN( preset_resort ) ) && ( preset_resort > 0 ) ) {
                        context.commit( 'set_value', { collection: 'selections', attribute: 'resort', data: preset_resort } );
                    }
                }

                context.dispatch( 'fetch' );
            }
        },

        fetch: function( context ) {
            context.commit( 'set_value', { attribute: 'loader', data: true } );
            context.commit( 'set_value', { attribute: 'response', data: [] } );
            jQuery.ajax(
                //this.state.api_url_base + '/rest/api/listings/search',
                window.DVCA_PARAMS['CMSREST'] + '/rest/api/listings/search',
                {
                    dataType: 'json',
                    method: 'POST',
                    data: context.state.selections,
                    success: function( response ) {
                        context.commit( 'set_value', { attribute: 'response', data: response } );
                        context.commit( 'set_value', { attribute: 'loader', data: false } );
                    }
                }
            );
        },

        refresh: function( context ) {
            context.commit( 'set_value', { attribute: 'loader', data: true } );

            setTimeout( function() {
                context.dispatch( 'fetch' );
            }, 375 );
        },

        /*
        load_detail: function( context, parameters ) {
            console.log("LISTING: ", '/rest/listing/DVCA' + parameters.id_account + '-' + parameters.id)
            console.log("LISTING ORIGIN:", this.state.api_url_base + '/listing/DVCA' + parameters.id_account + '-' + parameters.id)
            
            jQuery.ajax(
                // this.state.api_url_base + '/listing/DVCA' + parameters.id_account + '-' + parameters.id,
                '/rest/listing/DVCA' + parameters.id_account + '-' + parameters.id,
                {
                    dataType: 'json',
                    method: 'GET',
                    success: function( response ) {
                        context.commit( 'set_value', { attribute: 'detail', data: response } );
                    }
                }
            )
        }
        */
    },

    modules: {

    },
} );
